import { SET_DECISION_TREES } from '../../../actions/types';

const INITIAL_STATE = {
  decisionTrees: {},
  simplrAccountId: null,
};

const selectedPartnerTrees = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DECISION_TREES:
      return {
        trees: action.trees,
        simplrAccountId: action.simplrAccountId,
      };
    default:
      return state;
  }
};

export default selectedPartnerTrees;
